import { Modal, Portal, Resizable, Sidebar, useCustomEvent, useStorage, View } from '@fold-dev/core'
import { Outlet, useNavigate, useParams } from 'react-router'
import { removeURLTask, scrollDown } from '../helpers'
import { useMemo, useRef } from 'react'

export const SidebarModalLayout = (props: any) => {
    const { view } = useParams()
    const navigate = useNavigate()

    const handleDismiss = () => {
        navigate(removeURLTask(window.location.href))
        window['TASK_HISTORY'] = []
    }

    return (
        <Modal
            disableBackgroundDismiss
            width="calc(100% - var(--task-modal-margin))"
            height="calc(100% - var(--task-modal-margin))"
            className="task-modal"
            portal={Portal}
            //anchor="middle-center"
            onDismiss={handleDismiss}
            isVisible={true}
            style={{
                overflow: 'hidden',
                '--f-modal-body-padding': 0,
            }}>
            <Outlet />
        </Modal>
    )
}

export const ResizableSidebar = ({ key = 'FRONTEER_RESIZABLE_SIDEBAR_WIDTH', children, ...rest }) => {
    const { view } = useParams()
    const navigate = useNavigate()
    const { getStorage, setStorage } = useStorage()
    const width = useMemo(() => +getStorage(key) || 300, [])

    const handleNavChange = (width) => {
        setStorage(key, width)
    }

    return (
        <Sidebar
            border="none"
            bgToken="surface"
            {...rest}>
            <Resizable
                column
                position="end"
                alignItems="flex-start"
                alignContent="flex-start"
                justifyContent="flex-start"
                onChange={handleNavChange}
                width={width}
                max={1000}
                min={150}
                height="100%"
                handle={<></>}
                railProps={{ style: { '--f-resizable-color': 'transparent' } }}>
                <View
                    position="absolute"
                    width="100%"
                    height="100%"
                    style={{ overflow: 'auto', inset: 0 }}>
                    {children}
                </View>
            </Resizable>
        </Sidebar>
    )
}

export const SidebarLayout = ({ key = 'FRONTEER_SIDEBAR_LAYOUT_WIDTH', children, ...rest }) => {
    const { view } = useParams()
    const navigate = useNavigate()
    const { getStorage, setStorage } = useStorage()
    const width = useMemo(() => +getStorage(key) || 800, [])

    const handleNavChange = (width) => {
        setStorage(key, width)
    }

    return (
        <Sidebar
            right
            bgToken="surface"
            gap={20}>
            <Resizable
                column
                position="start"
                alignItems="flex-start"
                alignContent="flex-start"
                justifyContent="flex-start"
                onChange={handleNavChange}
                width={width}
                max={750}
                min={300}
                height="100%"
                handle={<></>}
                railProps={{ style: { '--f-resizable-color': 'transparent' } }}>
                <View
                    position="absolute"
                    width="100%"
                    height="100%"
                    style={{ overflow: 'auto', inset: 0 }}>
                    <Outlet />
                </View>
            </Resizable>
        </Sidebar>
    )
}

export const SidebarArea = ({ key = 'FRONTEER_SIDEBAR_WIDTH', children, ...rest }) => {
    const { getStorage, setStorage } = useStorage()
    const width = useMemo(() => +getStorage(key) || 275, [])

    const handleNavChange = (width) => {
        setStorage(key, width)
    }

    return (
        <Sidebar
            
            className="sidebar-area"
            {...rest}>
            <Resizable
                column
                position="start"
                alignItems="flex-start"
                alignContent="flex-start"
                justifyContent="flex-start"
                onChange={handleNavChange}
                width={width}
                max={2000}
                min={350}
                height="100%"
                bg="transparent"
                handle={<></>}
                railProps={{ style: { '--f-resizable-color': 'transparent', 'zIndex': 2000 } }}>
                <View
                    column
                    position="absolute"
                    width="100%"
                    height="100%"
                    justifyContent="flex-start"
                    className="sidebar-area__inner"
                    style={{ inset: 0 }}>
                    {children}
                </View>
            </Resizable>
        </Sidebar>
    )
}

export const SidebarAreaRoute = ({ key = 'FRONTEER_SIDEBAR_ROUTE_WIDTH' }) => {
    const { getStorage, setStorage } = useStorage()
    const width = useMemo(() => +getStorage(key) || 750, [])
    const ref = useRef(null)

    const handleNavChange = (width) => {
        setStorage(key, width)
    }

    const handleScrollDown = () => {
        scrollDown(ref.current)
    }

    useCustomEvent('sidebararearoute:scroll-down', handleScrollDown)

    return (
        <Sidebar
            right
            border="none"
            className="sidebar-area-route">
            <Resizable
                column
                position="start"
                alignItems="flex-start"
                alignContent="flex-start"
                justifyContent="flex-start"
                onChange={handleNavChange}
                width={width}
                max={2000}
                min={250}
                height="100%"
                bg="transparent"
                handle={<></>}
                railProps={{ style: { '--f-resizable-color': 'transparent', 'zIndex': 2000 } }}>
                <View
                    column
                    ref={ref}
                    position="absolute"
                    width="100%"
                    height="100%"
                    justifyContent="stretch"
                    className="f-scrollbar"
                    style={{ inset: 0, overflow: 'scroll' }}>
                    <Outlet />
                </View>
            </Resizable>
        </Sidebar>
    )
}

export const InboxResizable = ({ children, key = 'FRONTEER_INBOX_RESIZABLE_WIDTH' }) => {
    const { getStorage, setStorage } = useStorage()
    const width = useMemo(() => +getStorage(key) || 750, [])
    const ref = useRef(null)

    const handleNavChange = (width) => {
        setStorage(key, width)
    }

    const handleScrollDown = () => {
        scrollDown(ref.current)
    }

    useCustomEvent('sidebararearoute:scroll-down', handleScrollDown)

    return (
        <Sidebar
            right
            border="none"
            className="sidebar-area-route">
            <Resizable
                column
                position="start"
                alignItems="flex-start"
                alignContent="flex-start"
                justifyContent="flex-start"
                onChange={handleNavChange}
                width={width}
                max={2000}
                min={250}
                height="100%"
                bg="transparent"
                handle={<></>}
                railProps={{ style: { '--f-resizable-color': 'transparent', 'zIndex': 2000 } }}>
                {children}
            </Resizable>
        </Sidebar>
    )
}
